import React, { useContext } from 'react';

import InfosPopin from 'components/object/InfosPopin';

import { ContextBlock } from "context/ContextBlock";


const BlockInfosPopin = () => {

  //generic
  const {
    infosPopinType,
    infosPopinMsg,
    infosPopinTitle,
    openInfosPopin, setOpenInfosPopin,
    infosPopinMsgIsHTML, setInfosPopinMsgIsHTML
  } = useContext(ContextBlock);


  return (
    <InfosPopin
      setOpen={setOpenInfosPopin}
      open={openInfosPopin}
      type={infosPopinType}
      title={infosPopinTitle}
      msg={infosPopinMsg}
      isHTML={infosPopinMsgIsHTML}
      setIsHTML={setInfosPopinMsgIsHTML}
    />
  );
};

export default BlockInfosPopin;
